module.exports = __webpack_public_path__ + "img/image001.49499e2a.jpg";